export default __webpack_public_path__ + "static/media/EcommerceServicesLebenswerkBusinessManagement6.00da9424.png";